module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "sorting1"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regionValue),
      expression: "regionValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.regionValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fiteredResultGA]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All GA")]), _vm._v(" "), _vm._l((_vm.journey_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n              " + _vm._s(item.value) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 clear_button"
  }, [_c('button', {
    staticClass: "inline",
    on: {
      "click": _vm.clearStatusGA
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), (this.user.roleName == 'Admin') ? _c('div', {
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'VehicleCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn"
  }, [_vm._v("Add New")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "export-btn"
  }, [_c('button', {
    staticClass: " btn gradientbt",
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("\n          Export Vehicle\n        ")])]), _vm._v(" "), _c('v-server-table', {
    ref: "vehicleTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-730f9adf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/vehicles/Vehicles.vue
// module id = 1995
// module chunks = 1